import { render, staticRenderFns } from "./BagLabelDialog.vue?vue&type=template&id=2ff60d6c&scoped=true"
import script from "./BagLabelDialog.vue?vue&type=script&lang=js"
export * from "./BagLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./BagLabelDialog.vue?vue&type=style&index=0&id=2ff60d6c&prod&scoped=true&lang=css"
import style1 from "./BagLabelDialog.vue?vue&type=style&index=1&id=2ff60d6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff60d6c",
  null
  
)

export default component.exports